<template>
  <div class="custom-main custom-theme">
    <a-form class="ant-advanced-search-form">
      <div class="gpws-menu-title">
        <span>&nbsp;</span>已配送处方
      </div>
      <a-row class="searchrow width-style-auto">
        <a-col span="8">
          <a-form-item label="流转时间">
            <a-date-picker v-model="search.startDate" placeholder="请选择就诊开始日期" style="width: 120px;"/>至<a-date-picker v-model="search.endDate" placeholder="请选择就诊结束日期" style="width: 120px;"/>
          </a-form-item>
        </a-col>
        <a-col span="16">
          <a-form-item style="float: right;" :colon="false" label="关键字">
            <a-input v-model="search.keyword" placeholder="请输入处方单号/患者姓名检索">
              <img class="search-btn" slot="addonAfter" src="../../../assets/img/search.png" @click="searchAction"/>
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true}"
             rowKey="id" :dataSource="grid.data" :pagination="grid.pagination"
             @change="gridChangeAction" :scroll="{ x: '100%' }">
      <span slot="index" slot-scope="text, record, index">
        {{(((grid.pagination.current -1 ) * grid.pagination.pageSize) + index + 1) }}
      </span>
      <span slot="operate" slot-scope="text, record, index">
        <a @click="()=>receiveAction(record.id)">收货确认</a>
          <a-divider type="vertical" />
        <a @click="()=>detailAction(record.id)">详情</a>
      </span>
    </a-table>
    <a-modal title="处方收货确认" :visible="modal.visible" @ok="receiveRecipeOk" @cancel="receiveRecipeCancel">
      <a-form-item label="收货码" :label-col="{sm: 8, md: 6, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 14, md: 16, lg: 18, xl: 18, xxl: 18 }">
        <a-input v-model="modal.salt" placeholder="请输入处方收货码."/>
      </a-form-item>
    </a-modal>
    <detail ref="detail"/>
  </div>
</template>

<script>
  import Detail from "@/components/roam/recipe/Detail";
  export default {
    name: "DeliveredRecipe",
    components: {Detail},
    data() {
      return {
        loading: false,
        search:{
          keyword:'',
          startDate:'',
          endDate:''
        },
        grid: {
          loading: false,
          columns: columns,
          data: [],
          pagination: this.$pagination
        },
        modal:{
          visible:false,
          salt:'',
          roamId:''
        },
        drawer:{
          visible:false
        }
      }
    },
    beforeCreate() {
      let data = [{
        text: "首页",
        path: ""
      }, {
        text: "处方流转",
        path: ""
      }, {
        text: "已配送处方",
        path: ""
      }];
      this.$store.commit('updateBreadcrumb', data);
    },
    mounted: function () {
      this.searchAction();
    },
    methods: {
      receiveAction:function (id){
        this.modal.roamId = id;
        this.modal.visible = true;
      },
      receiveRecipeOk:function (){
        const self = this;
        /*if(undefined == this.modal.salt || null == this.modal.salt || '' == this.modal.salt){
          this.$message.error({content: '请先输入四位处方收货码.', duration: 2});
          return false;
        }
        if(this.modal.salt.length != 4){
          this.$message.error({content: '处方收货码为四位数字码.', duration: 2});
          return false;
        }*/

        this.$axios.post('/api/clinic/roam/recipe/'+this.modal.roamId+'/receive').then(function(res){
          if(res.msg.flag == 0){
            self.$message.success({content: '流转处方收货确认成功.', duration: 2});
            self.receiveRecipeCancel();
            self.searchAction();
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(res){
        });
      },
      receiveRecipeCancel:function (){
        this.modal.roamId = '';
        this.modal.salt=''
        this.modal.visible = false;
      },
      detailAction:function(id){
        this.$refs.detail.showDrawer(id);
      },
      buildParams:function(){
        let startDate = '', endDate = '';
        if(undefined != this.search.startDate && null != this.search.startDate && '' != this.search.startDate){
          startDate = this.formatDate(new Date(this.search.startDate));
        }
        if(undefined != this.search.endDate && null != this.search.endDate && '' != this.search.endDate){
          endDate = this.formatDate(new Date(this.search.endDate));
        }

        return {'entity.keyword': this.search.keyword, 'entity.status': 'D_DELIVERED', 'startTime': startDate, 'endTime': endDate};
      },
      /**
       * 查询按钮动作
       */
      searchAction: function () {
        Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
        let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
        this.loadGrid(params);
      },
      /**
       * 分页条操作
       */
      gridChangeAction: function (pagination, filters, sorter) {
        Object.assign(this.grid, {pagination: pagination});
        let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
        this.loadGrid(params);
      },
      /**
       * 请求单页数据
       */
      loadGrid: function (params) {
        const self = this;
        this.grid.loading = true;
        this.$axios.get('/api/clinic/roam/recipes', {params: params}).then(function (res) {
          self.grid.loading = false;
          if (res.msg.flag == 0) {
            if(null == res.biz || res.biz.empty){
              self.$message.info({content: res.msg.message, duration: 2});
              Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
            }else{
              Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
            }
          } else {
            self.$message.error(res.msg.message, 2);
          }
        }, function (res) {
          self.grid.loading = false;
        });
      }
    }
  }
  /**
   * 列部分
   * @type {({scopedSlots: {customRender: string}, width: number, fixed: string, title: string, align: string}|{customRender: (function(*=, *, *): *), dataIndex: string, width: number, title: string, key: string})[]}
   */
  const columns = [
    {
      title: '序号',
      align: 'center',
      fixed: 'left',
      width: 60,
      scopedSlots: {customRender: 'index'}
    },
    {
      title: '处方单号',
      dataIndex: 'code',
      key: 'code',
      width: 150,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '患者姓名',
      dataIndex: 'name',
      key: 'name',
      width: 100,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '患者电话',
      dataIndex: 'phone',
      key: 'phone',
      width: 120,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '处方类型',
      dataIndex: 'type',
      key: 'type',
      width: 100,
      align: 'center',
      customRender:(text, record, index) =>{
        if(record.type === 'SDP'){
          return '专方';
        }else{
          return '普方';
        }
      }
    },
    {
      title: '就诊医院',
      key: 'hospitalName',
      dataIndex: 'hospitalName',
      width: 150,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '开方医生',
      key: 'doctorName',
      dataIndex: 'doctorName',
      width: 100,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '取药方式',
      key: 'takeName',
      dataIndex: 'takeName',
      width: 100,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '流转时间',
      key: 'applyTime',
      dataIndex: 'applyTime',
      width: 150,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '配送时间',
      key: 'deliveryTime',
      dataIndex: 'deliveryTime',
      width: 150,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '收件人姓名',
      key: 'consigneeName',
      dataIndex: 'consigneeName',
      width: 100,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '收件人电话',
      key: 'consigneePhone',
      dataIndex: 'consigneePhone',
      width: 120,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '详细地址',
      key: 'address',
      dataIndex: 'address',
      width: 200,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '处方金额/结算金额',
      key: 'amount',
      align: 'center',
      fixed:'right',
      width: 140,
      customRender:(text, record, index) =>{
        return record.amount == undefined || record.amount == null ? '-' : (record.amount.toFixed(2)+' / ' + record.roamAmount.toFixed(2));
      }
    },
    {
      title: '操作',
      key: 'id',
      align: 'center',
      fixed:'right',
      width: 180,
      scopedSlots: {customRender: 'operate'}
    }
  ];
</script>
<style scoped>
  .row-h-40 {
     height: 40px;
     line-height: 40px;
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 4px;
    padding-right: 4px;
   }

  .row-h-36 {
    height: 36px;
    line-height: 36px;
  }
</style>
